import * as actions from '../../redux/actions';

import React, { useEffect, useState } from 'react';

import ApiUrls from '../../../../services/apiUrls';
import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import GoogleMapReact from 'google-map-react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';

const UnderLine = () => {
	return (
		<div
			style={{
				width: '70px',
				height: '3px',
				backgroundColor: '#ff6219',
				marginTop: 10,
			}}
		></div>
	);
};


const thaebusOffices = [
	{
		city: 'Casa Matriz',
		offices: [
			{
				officeName: 'Calle Bima 3032, Parque Industrial, Puerto Montt. ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-41.456283, -72.961327',
				// contact:' 34 2210329 - 34 2210330'
			},
		],
		officeImage: 'office1'
	},
	{
		city: 'Santiago',
		offices: [
			{
				officeName: 'Nicasio Retamales 44, Oficina 98. ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-33.45434, -70.688136',
				// contact:' 34 2210329 - 34 2210330'
			},
		],
		officeImage: 'office2'
	},
	{
		city: 'Puerto Montt',
		offices: [
			{
				officeName: 'Diego Portales 1001, Oficina 29. ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-41.476149, -72.948974',
				// contact:' 34 2210329 - 34 2210330'
			},
		],
		officeImage: 'office3'
	},
	{
		city: 'Osorno',
		offices: [
			{
				officeName: 'Errázuriz 1400, Oficina 6. ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-40.572993, -73.125659',
				// contact:' 34 2210329 - 34 2210330'
			},
		],
		officeImage: 'office4'
	},
];

const busesahumadaOffices = [
	{
		city: 'Los Andes',
		offices: [
			{
				officeName: 'Terrapuerto Los Andes: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.83621858653924, -70.5465673090741',
				contact: ' 34 2210329 - 34 2210330'
			},
			{
				officeName: 'Oficina Calle Larga: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.85255063980445, -70.6248065539757',
				contact: ' 34 2462902'
			},
			{
				officeName: 'Oficina Rinconada:',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.832950322155774, -70.68892666450576',
				contact: ' 34 2401791'
			},
		],
		officeImage: 'office1'
	},

	{
		city: 'Santiago',
		offices: [
			{
				officeName: 'Los Héroes Internacional: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-33.44423896334647, -70.65692033236691',
				contact: ' 34 2210352'
			},
			{
				officeName: 'Los Héroes Nacional: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-33.44423896334647, -70.65692033236691',
				contact: ' 34 2210351'
			},
		],
		officeImage: 'office2'
	},

	{
		city: 'San Felipe',
		offices: [
			{
				officeName: 'Oficinas San Felipe: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.74240410183264, -70.71724189999999',
				contact: " 34 2210342 - 34 2210343"
			},
		],
		officeImage: 'office3'
	},

	{
		city: 'Valparaíso',
		offices: [
			{
				officeName: 'Servicio Internacional: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-33.04697009766945, -71.60604718540685',
				contact: ' 34 2210357'
			},
		],
		officeImage: 'office4'
	},

	{
		city: 'Santuario Auco',
		offices: [
			{
				officeName: 'Santuario Auco: ',
				mapLink: `https://www.google.com/maps/search/?api=1&query=-32.89270700474266, -70.67602829317131`,
				contact: ' 34 2210356'
			},
		],
		officeImage: 'office5'
	},

	{
		city: 'Mendoza',
		offices: [
			{
				officeName: 'Mendoza: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.894841026652266, -68.8301038',
				contact: ' +54 261 4316281'
			},
		],
		officeImage: 'office6'
	},


];
const arzolaOffices = [
	{
		city: 'Cabrero',
		offices: [
			{
				officeName: 'Terminal Cabrero Santa Catalina, oficina 10. ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-37.035384089523305, -72.40631531729635'
				// contact: ' 34 2210329 - 34 2210330'
			},
			{
				officeName: 'Oficina Calle Larga: ',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.85255063980445, -70.6248065539757',
				contact: ' 34 2462902'
			},
			{
				officeName: 'Oficina Rinconada:',
				mapLink: 'https://www.google.com/maps/search/?api=1&query=-32.832950322155774, -70.68892666450576',
				contact: ' 34 2401791'
			},
		],
		officeImage: 'office1'
	},




];

export const OfficesList4 = ({ officeLocations, smallHeading, boldHeading, image, operator }) => {
	const isExpresoNorto = operator && operator.operator_name === 'expressonorte';
	const isBusesAhumada = operator && operator.operator_name === 'busesahumada';
	const isThaebus = operator && operator.operator_name === 'thaebus';
	const isArzola = operator && operator.operator_name === 'arzola';

	const [selectedOffice, setSelectedOffice] = useState(
		isBusesAhumada ? busesahumadaOffices[0] : isArzola ? arzolaOffices[0] : isThaebus ? thaebusOffices[0] : { offices: [] }
	);

	// const [selectedOffice, setSelectedOffice] = useState( busesahumadaOffices[0]);

	const officeData = isBusesAhumada ? busesahumadaOffices : isArzola ? arzolaOffices : isThaebus ? thaebusOffices : "";


	console.log("officedata", officeData, selectedOffice);

	return (
		<div className="themes-offices" >

			<div className="new-container" style={{ marginTop: 40}}>
				<h2 className="capitalize font10 less-bold-text mb5">{smallHeading}</h2>
				<h1 className="capitalize font13 bold-text mb5 black-text-color">{boldHeading}</h1>
				<div className="offices" >
					<ul className="office__list__ahumada" 
					style={{
                     backgroundColor: operator.operator_name === 'arzola' ? operator.color_codes.footer_color : '', 
                    }}>
						{/* {officeData.map((item, index) => (
              <li
                onClick={() => setSelectedOffice(item)}
                className={`
                                        cursor-pointer
                                        office__item
                                        ${
                                          isExpresoNorto
                                            ? ''
                                            : index % 2 === 0
                                            ? 'background-light-blue'
                                            : 'background-dark-blue'
                                        }
                                        ${item.city === selectedOffice.city && 'selected-location'}
                                   `}
              >
                <span className="office__name__ahumada font11">{item.city}</span>
              </li>
              // </>
            ))} */}
						{Array.isArray(officeData) &&
							officeData.map((item, index) => (
								<li
									onClick={() => setSelectedOffice(item)}
									className={`cursor-pointer office__item ${isExpresoNorto ? '' : index % 2 === 0 ? 'background-light-blue' : 'background-dark-blue'
										} ${item.city === selectedOffice.city && 'selected-location'}`}
									key={index}
									style={{
										backgroundColor: operator.operator_name === 'arzola' ? operator.color_codes.footer_color : '', // Apply footer_color if operator is arzola
									}}
								>
									<span className="office__name__ahumada font11">{item.city}</span>
								</li>
							))}
					</ul>
					<div className="office__map">
						<div className="office__map-view">

							<img src={getIcons(selectedOffice.officeImage)} className="about-service-image" />

						</div>
						<div
							className="office__map-details "
							style={
								isExpresoNorto
									? {
										padding: '20px 30px',
										justifyContent: 'flex-start',
										alignItems: 'flex-start',
										width: '60%',
										overflowY: 'scroll',
									}
									: {}
							}
						>
							<div className="office__map-details-text">
								<div className='font13 bold-text'>{selectedOffice.city}</div>
								<UnderLine />

								{/* {!image ? (
                  !isExpresoNorto ? ( */}
								{selectedOffice.offices.map((item, i) => (
									<div className="mt-2 mb-3">
										<div className="d-flex align-items-center w-100">

											<img
												src={getIcons('Destination')}
												style={{ height: '30px', width: 'auto' }}
												alt=""
											/>
											<span
												className="selected-location-name d-inline-block pb-0 pr-1 mb-0 font10 bold-text"
												style={{ borderBottom: 'none', width: 'auto', marginTop: '3px' }}
											>
												{item.officeName}
											</span>
											<span className='d-inline-block pb-0 pr-1 mb-0 font10'
												style={{ borderBottom: 'none', width: 'auto', marginTop: '3px' }}
											>
												{item.contact}
											</span>

										</div>
										<div className='capsule-and-link'>
											<span className='capsule'><a href={item.mapLink} target="_blank" >Ver mapa</a></span>
										</div>

									</div>
								))
								}
								{/* ) : (
                    <React.Fragment>
                      <span className="selected-location-name">{selectedOffice.city}</span>
                      <div>
                        <span className="selected-location-contact-no">{selectedOffice.phone}</span>
                        <br />
                        <span className="selected-location-address">{selectedOffice.address}</span>
                      </div>
                    </React.Fragment>
                  )
                ) : (
                  <OperatorServices operator={operator} selectedOffice={selectedOffice} />
                )} */}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const OperatorServices = ({ operator, selectedOffice }) => {
	return (
		<div>
			<span className="selected-location-name">{selectedOffice.title}</span>
			<div className="service-item lh-1-3">
				{selectedOffice.features.map((val, i) => {
					return (
						<div className="features">
							<span
								style={{
									height: 2,
									width: 10,
									display: 'flex',
									backgroundColor:
										operator && operator.color_codes && operator.color_codes.secondary_color
											? operator.color_codes.secondary_color
											: '',
									marginRight: 5,
								}}
							></span>
							<span>{val.label}</span>
						</div>
					);
				})}
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(OfficesList4);



// WEBPACK FOOTER //
// ./src/features/themes/common/OfficeList/OfficesList4.js